import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from './environments/environment';

if (typeof window !== 'undefined') {
  console.info('[video-site-portal-angular] Angular environment', environment.envName, {
    production: environment.production,
    apiUrl: environment.apiUrl,
    apiV1: environment.apiV1,
  });
}

// bootstrapApplication(IntakeFormComponent,{
//   providers: [
//     provideAnimations()
//   ]
// })
platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
